import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./control_dynamic.vue.js";
import _sfc_main$2 from "./control_string.vue.js";
import _sfc_main$3 from "./control_iterable.vue.js";
import { OrderedObject } from "../../lib/ordered_object.js";
/* empty css                                                   */
import { deserializeControlValue, serializeControlValue } from "../../lib/control.js";
import { computed, createBlock, createElementVNode, createTextVNode, createVNode, openBlock, renderSlot, resolveComponent, unref, withCtx } from "vue";
//#region src/components/controls/control_object.vue
var _hoisted_1 = {
	class: "dtc-control-object__contents",
	"data-qa": "dtc-control-object-item-value"
};
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlObject" }, {
	props: {
		value: {
			type: Object,
			default: () => ({})
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const entries = computed(() => {
			return props.value ? Object.entries(props.value) : [];
		});
		const keys = computed(() => {
			return entries.value.map(([key]) => key);
		});
		let currentId = 0;
		function generateNextId() {
			while (keys.value.includes(currentId.toString())) currentId++;
			return currentId.toString();
		}
		function generateItem() {
			return [generateNextId(), void 0];
		}
		function updateKey(key, value, updateItem) {
			if (keys.value.includes(key)) {
				const id = generateNextId();
				console.log(`Object cannot contain duplicate key '${key}', key set to '${id}'`);
				key = id;
			}
			updateEntry(key, value, updateItem);
		}
		function updateEntry(key, value, updateItem) {
			updateItem([key, value]);
		}
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, OrderedObject.fromEntries(e));
		}
		return (_ctx, _cache) => {
			const _component_dt_stack = resolveComponent("dt-stack");
			return openBlock(), createBlock(_sfc_main$3, {
				value: entries.value,
				disabled: __props.disabled,
				"generate-item": generateItem,
				"onUpdate:value": updateValue
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				prefix: withCtx(() => [..._cache[0] || (_cache[0] = [createTextVNode(" { ", -1)])]),
				item: withCtx(({ item, update }) => [createVNode(_component_dt_stack, {
					direction: "row",
					gap: "200",
					align: "end"
				}, {
					default: withCtx(() => [createVNode(_component_dt_stack, {
						direction: "row",
						gap: "200",
						"data-qa": "dtc-control-object-item-key"
					}, {
						default: withCtx(() => [createVNode(_sfc_main$2, {
							value: item[0],
							disabled: __props.disabled,
							"onUpdate:value": (e) => updateKey(e, item[1], update)
						}, null, 8, [
							"value",
							"disabled",
							"onUpdate:value"
						]), _cache[1] || (_cache[1] = createElementVNode("span", null, ":", -1))]),
						_: 2
					}, 1024), createElementVNode("div", _hoisted_1, [createVNode(_sfc_main$1, {
						class: "dtc-control-object__contents",
						"input-class": "d-gc-full",
						value: unref(serializeControlValue)(item[1]),
						disabled: __props.disabled,
						"onUpdate:value": (e) => updateEntry(item[0], unref(deserializeControlValue)(e), update)
					}, null, 8, [
						"value",
						"disabled",
						"onUpdate:value"
					])])]),
					_: 2
				}, 1024)]),
				suffix: withCtx(() => [..._cache[2] || (_cache[2] = [createTextVNode(" } ", -1)])]),
				_: 3
			}, 8, ["value", "disabled"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_object.vue.js.map